module.exports = __webpack_public_path__ + "img/album17_03.d2f9b80d.jpg";